import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5c8bf66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "second-div" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Logout")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-fill logoutLogo" }, null, -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "third-div" }
const _hoisted_8 = { class: "horizontal-list" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question-circle right-icon-design" }, null, -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-fill right-icon-design people" }, null, -1 /* HOISTED */))
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" First div: responsive clickable image "),
    _createElementVNode("div", {
      class: "first-div",
      onClick: $setup.onClickLogo
    }, [
      _createElementVNode("img", {
        class: "nav-logo-scan",
        src: require('@/assets/img/scan-logo.jpg'),
        alt: "Left Logo"
      }, null, 8 /* PROPS */, _hoisted_2)
    ]),
    _createCommentVNode(" Second div: long message text "),
    _createElementVNode("div", _hoisted_3, [
      ($setup.store.state.isAltLogin == true)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "logoutBtn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.logoutClick()))
          }, _hoisted_6))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString($setup.store.getters.approvalNotice), 1 /* TEXT */)
    ]),
    _createCommentVNode(" Third div: horizontal list "),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/InquiryInfo",
            class: "right-link"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            to: "/UserInfo",
            class: "right-link"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("img", {
            src: require('@/assets/img/logo.png'),
            alt: "Right Logo",
            class: "nav-logo-suzuki"
          }, null, 8 /* PROPS */, _hoisted_11)
        ])
      ])
    ])
  ]))
}